import React, { Component, } from 'react'
import { TabPane, FormGroup, Label, Input, Button } from 'reactstrap'
import initializePropPaneState from '../../../helpers/content/manageSets/initializePropPaneState';
import forOwn from 'mout/object/forOwn'
import { SetRawToScaleScoringForm, } from '../ManageSetsComponents'
import firebase from 'firebase'
import { db } from '../../../config/firebaseconfig'

/*
  <SetPropertiesPane
    nodes={this.props.nodes}
    sets={this.props.sets}
    activeSet={this.props.activeSet}
  />
*/

/*
Next Step: Settings Tab
  Settings for Set:
    1. Test, Subtest, or None. If test or subtest...
    2. Assign nodeTag
    3. Time limits
    4. DisplayName
    5. Assign max nodeLevels for reports
    6. Raw to Scale scoring


    Save
*/

class SetPropertiesPane extends Component {
  constructor(props) {
    super(props)

    this.state = {
      name: '',
      testType: 'None',
      nodeTag: '',
      timeLimit: 0,
      displayName: '',
      maxNodeLevels: 0,
      maxRaw: 0,
      rawToScaleScoring: {},
      isSaving: false,
      directions: '',
      sectionBreaks: '',
      timeManagementEasy: '',
      timeManagementHard: '',
      precisionQuestions: '',
      precisionComparables: '',
      dataRepresentationPassages: '',
      researchSummaryPassages: '',
      conflictingViewpointsPassages: '',
      licensable: false,
      navName: '',
      navCategory: '',
      setType: 'None',
      template: '',
    }

    this.handleChangeRawToScaleScoring = this.handleChangeRawToScaleScoring.bind(this)
    this.handleSave = this.handleSave.bind(this)
  }

  componentDidMount() {
    if (this.props.sets && this.props.activeSet) {
      const initialState = initializePropPaneState(this.props.sets[this.props.activeSet])
      this.setState(initialState)
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.activeSet !== nextProps.activeSet || this.props.sets === null) {
      if (nextProps.sets && nextProps.activeSet) {
        const initialState = initializePropPaneState(nextProps.sets[nextProps.activeSet])
        this.setState(initialState)
      }
    }
  }

  handleChange = e => {
    this.setState({
      [e.target.name]: e.target.value
    }, )
  }

  handleChangeRawToScaleScoring(raw, scale) {
    this.setState({
      rawToScaleScoring: {
        ...this.state.rawToScaleScoring,
        [raw]: scale,
      }
    })
  }

  handleSave() {
    if (this.props.activeSet && this.props.sets) {
      this.setState({isSaving: true})
      const sBreaks = this.state.sectionBreaks.split(',')
      const tmEasy = this.state.timeManagementEasy.split(',')
      const tmHard = this.state.timeManagementHard.split(',')
      const precQ = this.state.precisionQuestions.split(',')
      const precC = this.state.precisionComparables.split(',')
      const dataR = this.state.dataRepresentationPassages.split(',')
      const researchS = this.state.researchSummaryPassages.split(',')
      const confV = this.state.conflictingViewpointsPassages.split(',')
      db.collection('sets').doc(this.props.activeSet).update({
        name: this.state.name,
        testType: this.state.testType,
        nodeTag: this.state.nodeTag,
        timeLimit: this.state.timeLimit,
        displayName: this.state.displayName,
        maxNodeLevels: this.state.maxNodeLevels,
        maxRaw: this.state.maxRaw,
        rawToScaleScoring: this.state.rawToScaleScoring,
        directions: this.state.directions,
        sectionBreaks: sBreaks,
        timeManagementEasy: tmEasy,
        timeManagementHard: tmHard,
        precisionQuestions: precQ,
        precisionComparables: precC,
        dataRepresentationPassages: dataR,
        researchSummaryPassages: researchS,
        conflictingViewpointsPassages: confV,
        licensable: !!this.state.licensable,
        navName: this.state.navName,
        navCategory: this.state.navCategory,
        setType: this.state.setType,
        template: this.state.template,
      })
        .then(() => this.setState({isSaving: false}))
        .catch((err) => {
          this.setState({isSaving: false})
         
        })

    }
  }

  render() {

    const { licensable, testType, navName, navCategory, setType, template, } = this.state
    const { handleChange } = this
 
    let nodes = [<option key='nodeOptionNull' value=''></option>]
    if (this.props.nodes) {
      forOwn(this.props.nodes, (val, key, o) => {
        if (!val.deleted) {
          nodes.push(
            <option value={key} key={`nodeOption${key}`}>{val.name}</option>
          )
        }
      })
    }
    

    // node select
    const nodeTagger = (
      <Input
        type='select'
        name='nodeTag'
        id='nodeTag'
        value={testType === 'None' ? '' : this.state.nodeTag}
        onChange={(e) => this.handleChange(e)}
        disabled={testType === 'None'}
      >
        {nodes}
      </Input>
    )


    return (
      <TabPane tabId='3'>
        <FormGroup>
          <Label htmlFor='name'>Name</Label>
          <Input 
            type='text'
            name='name'
            id='name'
            value={this.state.name}
            onChange={(e) => this.handleChange(e)}
          />
        </FormGroup>
        <FormGroup>
          <Label for='licensable'>Licensable</Label>
          <Input 
            type='select' 
            name='licensable' 
            id='licensable'
            value={licensable}
            onChange={handleChange}
            disabled={testType !== 'Test' && setType !== 'Book'}
          >
            <option value={''}>No</option>
            <option value={true}>Yes</option>
          </Input>
        </FormGroup>
        {licensable &&
          <FormGroup>
            <Label for='navName'>Nav Name</Label>
            <Input
              type='text'
              name='navName'
              id='navName'
              value={navName}
              onChange={handleChange}
            />
          </FormGroup>
        }
        {licensable &&
          <FormGroup>
            <Label for='navCategory'>Nav Category</Label>
            <Input
              type='text'
              name='navCategory'
              id='navCategory'
              value={navCategory}
              onChange={handleChange}
            />
          </FormGroup>
        }        
        <FormGroup>
          <Label htmlFor='testType'>Test Type</Label>
          <Input 
            type='select'  
            name='testType'  
            id='testType' 
            value={testType} 
            onChange={(e) => this.handleChange(e)}
          >
            <option value='None'>None</option>
            <option value='Subtest'>Subtest</option>
            <option value='Test'>Test</option>
          </Input>
        </FormGroup>
        <FormGroup>
          <Label htmlFor='setType'>Set Type</Label>
          <Input 
            type='select'
            name='setType'
            id='setType'
            value={setType}
            onChange={(e) => this.handleChange(e)}
          >
            <option value='None'>None</option>
            <option value='Book'>Book</option>
            <option value='Chapter'>Chapter</option>
            <option value='Lesson'>Lesson</option>
            <option value='Mini-Test'>Mini-Test</option>
          </Input>
        </FormGroup>
        {setType !== 'None' &&
          <FormGroup>
            <Label htmlFor='template'>Template</Label>
            <Input
              type='select'
              name='template'
              id='template'
              value={template}
              onChange={(e) => this.handleChange(e)}
            >
              <option value=''></option>
              <option value='SAT Boot Camp'>SAT Boot Camp</option>
            </Input>
          </FormGroup>
        }
        {(testType === 'Test' || testType === 'Subtest') &&
        <div>
          <FormGroup>
            <Label htmlFor='timeLimit'>Time Limit (Minutes)</Label>
            <Input 
              type='text'
              name='timeLimit'
              id='timeLimit'
              value={testType === 'None' ? '' : this.state.timeLimit}
              onChange={(e) => this.handleChange(e)}
              disabled={testType === 'None'}
            />
          </FormGroup>
          <FormGroup>
            <Label htmlFor='displayName'>Display Name</Label>
            <Input 
              type='text'
              name='displayName'
              id='displayName'
              value={testType === 'None' ? '' : this.state.displayName}
              onChange={(e) => this.handleChange(e)}
              disabled={testType === 'None'}
            />
          </FormGroup>
          <FormGroup>
            <Label htmlFor='maxNodeLevels'>Max Node Levels</Label>
            <Input 
              type='select'
              name='maxNodeLevels'
              id='maxNodeLevels'
              value={testType === 'None' ? '' : this.state.maxNodeLevels}
              onChange={(e) => this.handleChange(e)}
              disabled={testType === 'None'}
            >
              <option value=''></option>
              <option value='1'>1</option>
              <option value='2'>2</option>
              <option value='3'>3</option>
              <option value='4'>4</option>
            </Input>
          </FormGroup>
          <FormGroup>
            <Label htmlFor='nodeTag'>Node Tag</Label>
            {nodeTagger}
          </FormGroup>
          <FormGroup>
            <Label htmlFor='maxRaw'>Max Raw Score</Label>
            <Input
              type='text'
              name='maxRaw'
              id='maxRaw'
              value={testType === 'None' ? '' : this.state.maxRaw}
              onChange={(e) => this.handleChange(e)}
              disabled={testType === 'None'}
            />
          </FormGroup>
          <FormGroup>
            <Label htmlFor='sectionBreaks'>Section/Passage Breaks (Comma-Separated)</Label>
            <Input
              type='text'
              name='sectionBreaks'
              id='sectionBreaks'
              value={testType === 'None' ? '' : this.state.sectionBreaks}
              onChange={(e) => this.handleChange(e)}
              disabled={testType === 'None'}
            />
          </FormGroup>
          <FormGroup>
            <Label htmlFor='timeManagementEasy'>Time Management Easy Questions (Comma-Separated)</Label>
            <Input
              type='text'
              name='timeManagementEasy'
              id='timeManagementEasy'
              value={testType === 'None' ? '' : this.state.timeManagementEasy}
              onChange={(e) => this.handleChange(e)}
              disabled={testType === 'None'}
            />
          </FormGroup>
          <FormGroup>
            <Label htmlFor='timeManagementHard'>Time Management Hard Questions (Comma-Separated)</Label>
            <Input
              type='text'
              name='timeManagementHard'
              id='timeManagementHard'
              value={testType === 'None' ? '' : this.state.timeManagementHard}
              onChange={(e) => this.handleChange(e)}
              disabled={testType === 'None'}
            />
          </FormGroup>
          <FormGroup>
            <Label htmlFor='precisionQuestions'>Precision Questions (Comma-Separated)</Label>
            <Input
              type='text'
              name='precisionQuestions'
              id='precisionQuestions'
              value={testType === 'None' ? '' : this.state.precisionQuestions}
              onChange={(e) => this.handleChange(e)}
              disabled={testType === 'None'}
            />
          </FormGroup>
          <FormGroup>
            <Label htmlFor='precisionComparables'>Precision Comparable (Comma-Separated)</Label>
            <Input
              type='text'
              name='precisionComparables'
              id='precisionComparables'
              value={testType === 'None' ? '' : this.state.precisionComparables}
              onChange={(e) => this.handleChange(e)}
              disabled={testType === 'None'}
            />
          </FormGroup>
          <FormGroup>
            <Label htmlFor='dataRepresentationPassages'>Data Representation Passage Numbers (Comma-Separated)</Label>
            <Input
              type='text'
              name='dataRepresentationPassages'
              id='dataRepresentationPassages'
              value={testType === 'None' ? '' : this.state.dataRepresentationPassages}
              onChange={(e) => this.handleChange(e)}
              disabled={testType === 'None'}
            />
          </FormGroup>
          <FormGroup>
            <Label htmlFor='researchSummaryPassages'>Research Summary Passage Numbers (Comma-Separated)</Label>
            <Input
              type='text'
              name='researchSummaryPassages'
              id='researchSummaryPassages'
              value={testType === 'None' ? '' : this.state.researchSummaryPassages}
              onChange={(e) => this.handleChange(e)}
              disabled={testType === 'None'}
            />
          </FormGroup>
          <FormGroup>
            <Label htmlFor='conflictingViewpointsPassages'>Conflicting Viewpoints (Comma-Separated)</Label>
            <Input
              type='text'
              name='conflictingViewpointsPassages'
              id='conflictingViewpointsPassages'
              value={testType === 'None' ? '' : this.state.conflictingViewpointsPassages}
              onChange={(e) => this.handleChange(e)}
              disabled={testType === 'None'}
            />
          </FormGroup>
          <FormGroup>
            <Label>Directions</Label>
            <Input 
              type='textarea'
              name='directions'
              id='directions'
              value={testType === 'None' ? '' : this.state.directions}
              onChange={(e) => this.handleChange(e)}
              disabled={testType === 'None'}
            />
          </FormGroup>
          <SetRawToScaleScoringForm
            sets={this.props.sets}
            activeSet={this.props.activeSet}
            rawToScaleScoring={this.state.rawToScaleScoring}
            maxRaw={this.state.maxRaw}
            handleChangeRawToScaleScoring={this.handleChangeRawToScaleScoring}
            handleSave={this.handleSave}
            isSaving={this.state.isSaving}
          />
        </div>}
        <Button 
            disabled={this.props.isSaving}
            onClick={() => this.handleSave()}
          >
            Save
        </Button>
      </TabPane>
    )
  }


}

export default SetPropertiesPane



// WEBPACK FOOTER //
// ./src/components/Content/ManageSetsComponents/SetPropertiesPane.js